import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Color, Path, Svg } from "react-native-svg";

const Shapes: FC<{ color?: Color; style?: StyleProp<ViewStyle> }> = ({ color, style }) => (
  <Svg style={style} viewBox="0 0 18 18" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m14.221 1.85 3.706 6.354A.53.53 0 0 1 17.47 9h-7.412a.53.53 0 0 1-.457-.796l3.706-6.353a.53.53 0 0 1 .914 0Zm-.457 1.318L10.98 7.941h5.568l-2.784-4.773ZM3.706 7.412a3.706 3.706 0 1 1 0-7.412 3.706 3.706 0 0 1 0 7.412Zm0-1.06a2.647 2.647 0 1 0 0-5.293 2.647 2.647 0 0 0 0 5.294Zm.53 4.765h5.822a.53.53 0 0 1 .53.53v5.823a.53.53 0 0 1-.53.53H4.235a.53.53 0 0 1-.53-.53v-5.824a.53.53 0 0 1 .53-.529Zm.528 5.823H9.53v-4.764H4.764v4.764Z"
      fill={color || "#000"}
    />
  </Svg>
);

export default Shapes;
